/**
 * Handlery pre navigáciu v poli záznamov (Add/Detail stránky).
 * @param {Array} items - pole položiek
 * @param {*} currentId - id aktuálnej položky
 * @param {function} setItem - callback na nastavenie položky (setForm...)
 * @param {function} [getId] - extrakcia id z položky, default x => x?.id
 */
export function createArrayNavigateHandlers(items, currentId, setItem, getId = (x) => x?.id) {
  const getIndex = () => {
    if (!items?.length || currentId == null) return -1;
    return items.findIndex((item) => getId(item) === currentId);
  };
  return {
    scrollToFirst: () => items?.length && setItem(items[0]),
    scrollUp: () => {
      const i = getIndex();
      if (i > 0) setItem(items[i - 1]);
    },
    scrollDown: () => {
      const i = getIndex();
      if (i >= 0 && i < items.length - 1) setItem(items[i + 1]);
    },
    scrollToLast: () => items?.length && setItem(items[items.length - 1]),
  };
}
